module.exports = __webpack_public_path__ + "img/prize2.43e2179f.png";